import React from 'react';

export const Wrench = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--wrench';
  color = color || '#0078D4';

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M4.99998 7.99998H7.99998V4.99998L4.49998 1.49998C5.61961 0.96525 6.87748 0.790782 8.10037 1.0006C9.32327 1.21041 10.451 1.79419 11.3284 2.67155C12.2058 3.5489 12.7895 4.67668 12.9994 5.89958C13.2092 7.12248 13.0347 8.38035 12.5 9.49998L18.5 15.5C18.8978 15.8978 19.1213 16.4374 19.1213 17C19.1213 17.5626 18.8978 18.1022 18.5 18.5C18.1022 18.8978 17.5626 19.1213 17 19.1213C16.4374 19.1213 15.8978 18.8978 15.5 18.5L9.49998 12.5C8.38035 13.0347 7.12248 13.2092 5.89958 12.9994C4.67668 12.7895 3.5489 12.2058 2.67155 11.3284C1.79419 10.451 1.21041 9.32327 1.0006 8.10037C0.790782 6.87748 0.96525 5.61961 1.49998 4.49998L4.99998 7.99998Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Wrench;
